import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const DropdownAnswer = ({ question, item, setSelectedAnswer }) => {
  const { t } = useTranslation();

  return <button
    onClick={() => setSelectedAnswer(question, item)}
    className={styles.answer + ' ' + (question.answer ? question.answer?.key === item.key ? styles.selected : styles.unselected : '')}
  >
    {t(item.text)}
  </button>;
}

export default DropdownAnswer;
